import { createReducer, on } from '@ngrx/store';
import { setElementVisibility } from './element-visibility.actions';
import { ElementsVisibilityState } from '@/app/api/plyca-dtos';

const initialState = new ElementsVisibilityState();

export const reducer = createReducer<ElementsVisibilityState>(
  initialState,
  on(setElementVisibility, (state, { payload }) => payload.visibilityState)
);
